import script from "./SiteFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SiteFooter.vue?vue&type=script&setup=true&lang=ts"

import "./SiteFooter.vue?vue&type=style&index=0&id=faab1226&lang=scss"

const __exports__ = script;

export default __exports__